export default __webpack_public_path__ + "static/media/Brandyn_Keating_AHV_In_Moms_We_Trust.6109ddc8.jpg";